import {
  CANADA_EST_AORS,
  CANADA_MST_AORS,
  convertClientTimeToAORTime,
  getCorrectedDate,
  getCurrentOffsetTime,
  getDateInUTCOffset,
} from 'src/app/utils/utils';

export function getCurrentTimeBasedOnView(
  aor: string | null,
  isAorView: boolean
): Date | null {
  return isAorView
    ? (convertCurrentTimeBasedOnAOROffset(aor) ?? new Date())
    : new Date();
}

export function convertUTCTimeBasedOnAOROffset(
  date: Date | string,
  aor: string
): Date | null {
  if (aor && CANADA_EST_AORS.includes(aor)) {
    return getDateInUTCOffset(date, -5);
  }

  if (aor && CANADA_MST_AORS.includes(aor)) {
    return getDateInUTCOffset(date, -7);
  }

  return getCorrectedDate(date);
}

export function convertCurrentTimeBasedOnAOROffset(aor: any): Date | null {
  if (aor && CANADA_EST_AORS.includes(aor)) {
    return getCurrentOffsetTime(-5);
  }

  if (aor && CANADA_MST_AORS.includes(aor)) {
    return getCurrentOffsetTime(-7);
  }

  return null;
}

export function convertUserTimeBasedOnAOROffset(
  date: Date | string | null,
  aor: string
): Date | null {
  if (aor && CANADA_EST_AORS.includes(aor)) {
    return convertClientTimeToAORTime(date, -5);
  }

  if (aor && CANADA_MST_AORS.includes(aor)) {
    return convertClientTimeToAORTime(date, -7);
  }

  return null;
}
